const vapidPublicKey = "BPaofrhMk81txQuL8o00Vfghcp-pN0pnmqoHHiDmlCqBJmitvxiOJGJiWJUpua8qF98C4sPW1YGE2mFU9qHPlqA";

document.addEventListener("DOMContentLoaded", function() {
    if ('serviceWorker' in navigator && 'PushManager' in window) {
        navigator.serviceWorker.register('/serviceworker.js').then(function(swReg) {
            //console.log('Service Worker registrado con éxito:', swReg);

            Notification.requestPermission().then(function(permission) {
                if (permission === "granted") {
                    //console.log("Permiso para notificaciones concedido.");

                    // Intentar obtener la ubicación
                    let latitude = null;
                    let longitude = null;

                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(
                            function(position) {
                                latitude = position.coords.latitude;
                                longitude = position.coords.longitude;

                                enviarSuscripcion(swReg, latitude, longitude);
                            },
                            function(error) {
                                console.warn("No se pudo obtener la ubicación. Procediendo sin coordenadas.");
                                enviarSuscripcion(swReg, latitude, longitude); // Sin coordenadas
                            }
                        );
                    } else {
                        console.warn("Geolocalización no soportada. Procediendo sin coordenadas.");
                        enviarSuscripcion(swReg, latitude, longitude); // Sin coordenadas
                    }
                } else {
                    console.warn("Permiso para notificaciones denegado.");
                }
            });
        }).catch(function(error) {
            console.error("Error al registrar el Service Worker:", error);
        });
    } else {
        console.warn("Push y Service Workers no están soportados por este navegador.");
    }
});

function enviarSuscripcion(swReg, latitude, longitude) {
    swReg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
    }).then(function(subscription) {
        const subscriptionData = subscription.toJSON();

        // Enviar la suscripción (con o sin coordenadas)
        fetch('/subscriptions', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                    subscription: {
                        endpoint: subscriptionData.endpoint,
                        keys: subscriptionData.keys,
                        latitude: latitude,
                        longitude: longitude
                    }
                })
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    if (data.reload) {
                        const url = window.location.href.split('?')[0];
                        const uniqueParam = `?state_id=${data.state_id}`;
                        window.location.replace(url + uniqueParam);
                    }
                } else {
                    console.error("Error al enviar la suscripción:", data.error);
                }
            })
            .catch(error => {
                console.error("Error al procesar la solicitud:", error);
            });
    }).catch(function(err) {
        console.error("No se pudo suscribir al usuario:", err);
    });
}

// Función auxiliar para convertir VAPID a Uint8Array
function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}